
import Table, { type RowData, type TableProps } from './Table';

export default Table;
export type { RowData, TableProps };
